import {ITheme} from 'contexts/ThemeContext';
import {Platform} from 'react-native';
import {getBottomSpace} from 'react-native-iphone-x-helper';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  minSize,
} from 'rn-responsive-styles';

export default (props: ITheme) =>
  CreateResponsiveStyle(
    {
      getRecordingButtonStyle: {
        height: 46,
        width: 145,
        borderRadius: 8,
        backgroundColor: props.colors.purple(0.13),
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
      },
      getRecordingText: {
        fontSize: 17,
        ...props.typography.interMedium,
        color: props.colors.purple(1),
      },
    },
    {
      [minSize(DEVICE_SIZES.SMALL_DEVICE)]: {},
    },
  )();
